import React from 'react';

import { StickerComponent, UiComponent } from 'components';
import { useIsMobile } from 'hooks';
import { StickerQuery } from 'queries';

function List() {
  const isMobile = useIsMobile();
  const { data, isLoading } = StickerQuery.useGetAll();

  const title = <UiComponent.PageTitle>스티커</UiComponent.PageTitle>;

  if (isMobile) {
    return (
      <StickerComponent.MobileList
        title={title}
        data={data || []}
        isLoading={isLoading}
      />
    );
  }

  return (
    <>
      {title}
      <StickerComponent.List data={data || []} />
    </>
  );
}

export default List;
